import {Types} from "../actions/noteActions";
import _ from "lodash";

const noteReducers = (state, action) => {

  console.log('action.type',action)

  switch (action.type) {
    case Types.NOTE_VIEW_DETAIL: {

      let newState = _.cloneDeep(state);

      newState.notes = {
        ...state.notes,
        detailView: action.show ? action.item : action.show
      }

      return newState;
    }
    case Types.NOTE_SAVING: {

      let newState = _.cloneDeep(state);

      newState.notes = {
        ...state.notes,
        saving: true
      }

      return newState;
    }
    case Types.NOTE_SAVED: {

      let newState = _.cloneDeep(state);

      newState.notes = {
        ...state.notes,
        saving: false,
        detailView: false
      }

      return newState;
    }
    default:
      return state;
  }
};

export default noteReducers;